import { CommunityOption } from "../../types/community";
import api from "../../client";
import { useQuery } from "react-query";

export interface CommunityOptionListResponseData {
  data: {
    results: CommunityOption[];
  };
}

export const getCommunityOptions = async () => {
  const { data } =
    await api.get<CommunityOptionListResponseData>("/community-options");
  return data;
};

export const useCommunityOptions = () => {
  return useQuery("community-options", getCommunityOptions);
};
